import { cn } from '@repo/tailwind-config/tailwind.functions'

type Props = {
  status?: 'active' | 'inactive'
}

const StatusIndicator = ({ status = 'inactive' }: Props) => {
  return (
    <div className="h-6 w-6 flex items-center justify-center">
      <div
        className={cn('absolute h-6 w-6 rounded-full bg-red-light animate-pulse', {
          'bg-green-light': status === 'active'
        })}
      />
      <div
        className={cn('relative h-2 w-2 rounded-full bg-red', {
          'bg-green': status === 'active'
        })}
      />
    </div>
  )
}

export default StatusIndicator
